import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import langIsEn from '../../utils/langIsEn';
import styles from './ContentDetailInfo.css';

class ContentDetailInfo extends Component {
  static propTypes = {
    infos: PropTypes.object.isRequired,
  };

  breakToLines(text) {
    return text.split('\n').map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      );
    });
  }

  renderKeyValue(key, value) {
    if (!value) {
      return null;
    }

    return (
      <p>
        <span className={styles.infoKey}>{key}:<br /></span>
        <span className={styles.infoValue}>{this.breakToLines(value)}</span>
      </p>
    );
  }

  render() {
    const { infos } = this.props;

    return (
      <div className={classnames('container', styles.detailInfoContainer)}>
        {langIsEn() &&
          <div className={styles.engContentInfos}>
            {this.renderKeyValue('Scope', infos.engScope)}
            {this.renderKeyValue('Project Partner', infos.engPartner)}
            {this.renderKeyValue('Client', infos.engClient)}
          </div>
        }
        {!langIsEn() &&
          <div className={styles.contentInfos}>
            {this.renderKeyValue('Scope', infos.chtScope)}
            {this.renderKeyValue('Project Partner', infos.chtPartner)}
            {this.renderKeyValue('Client', infos.chtClient)}
          </div>
        }
      </div>
    )
  }
}

export default ContentDetailInfo;



// WEBPACK FOOTER //
// ./src/components/content-detail-info/ContentDetailInfo.js